import { Link } from "react-router-dom";
import { GitCompare, X } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { inr } from "@/lib/api";
import { bust, thumb } from "@/lib/img";

export default function CompareBar() {
  const { compare, removeFromCompare, clearCompare } = useApp();
  if (compare.length === 0) return null;

  return (
    <div data-testid="compare-bar" className="fixed left-1/2 -translate-x-1/2 bottom-20 lg:bottom-6 z-40 w-[calc(100%-2rem)] max-w-3xl">
      <div className="bg-[#292724] text-white rounded-2xl shadow-2xl px-4 py-3 flex items-center gap-3 border border-white/10 backdrop-blur-md">
        <GitCompare className="w-4 h-4 text-[#d4af37] shrink-0" />
        <div className="text-xs eyebrow text-[#d4af37] hidden sm:block">Compare</div>
        <div className="flex-1 flex items-center gap-2 overflow-x-auto">
          {compare.map((c) => (
            <div key={c.id} className="flex items-center gap-2 bg-white/10 rounded-full pl-1 pr-2 py-1 shrink-0">
              <img loading="lazy" src={thumb(bust(c.image, c.updated_at), 100)} alt="" className="w-6 h-6 rounded-full object-cover object-center" />
              <span className="text-xs whitespace-nowrap max-w-[120px] truncate">{c.name}</span>
              <button onClick={() => removeFromCompare(c.id)} className="text-white/70 hover:text-white"><X className="w-3 h-3" /></button>
            </div>
          ))}
          {compare.length < 3 && <span className="text-xs text-white/50 whitespace-nowrap">+ Add up to {3 - compare.length} more</span>}
        </div>
        <Link to="/compare" data-testid="compare-bar-open" className="btn-gold text-xs !py-1.5 !px-4 whitespace-nowrap">Compare ({compare.length})</Link>
        <button onClick={clearCompare} className="text-white/60 hover:text-white text-xs hidden sm:inline">Clear</button>
      </div>
    </div>
  );
}
